import axios, { AxiosError, AxiosResponse } from "axios";
import { ClientPortalConfig } from "../types/generated/models";
// eslint-disable-next-line no-restricted-imports
import { useQuery } from "@tanstack/react-query";
import { useSnackbar } from "@powerdiary/components-library/lib";
import { useEffect } from "react";
import { showNetworkErrorSnackbar } from "../utils/networkErrorSnackbar";

export interface IClientPortalConfigHook {
    data?: ClientPortalConfig | null;
    isLoading: boolean;
}

export function useClientPortalConfig(guidKey: string): IClientPortalConfigHook {
    const { enqueueSnackbar } = useSnackbar();
    const { data, isLoading, error } = useQuery<AxiosResponse<ClientPortalConfig>, AxiosError>({
        queryKey: [`/api/v1/Home/GetClientPortalConfiguration`],
        queryFn: async (): Promise<AxiosResponse<ClientPortalConfig>> => {
            return axios.get<ClientPortalConfig>(`/api/v1/${guidKey}/Home/GetClientPortalConfiguration`);
        },
    });

    useEffect(() => {
        if (error) {
            if (error.request && !error.response) {
                showNetworkErrorSnackbar();
            } else {
                enqueueSnackbar("Please contact support with the steps to replicate.", {
                    variant: "error",
                    alertTitle: "Error getting client portal configuration",
                });
            }
        }
    }, [error, enqueueSnackbar]);

    return {
        data: data?.data,
        isLoading,
    };
}
